import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { addNewSpecialMark, addNewConfMark } from "../../../../redux/certificateReducer/actionsCertificate";
import Select from "react-select";
import { customErrorStyles, customStyles } from "../certificateInfo/optionsCertificateInfo";

import styles from "./CertificateModalWindow.module.css";

export default function CertificateModalWindow({
  licenseIdModal,
  showModal,
  setShowModal,
  modalWindowInputs,
  dataForEdit,
  setDataForEdit,
  type,
  setType,
}) {
  const dispatch = useDispatch();

  const usersLib = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.usersLibrary.map((item) => {
      return { ...item, key: "userid" };
    });
  });

  const [newData, setNewData] = useState(type === "edit" ? structuredClone(dataForEdit) : {});
  const [errors, setErrors] = useState({});
  const [saveKey, setSaveKey] = useState(false);

  const errorsFields = modalWindowInputs.nameColumn.map((item) => Object.values(item)).map((elem) => elem[2]);

  // useEffect(() => {
  // }, []);

  const handleChange = (e) => {
    switch (modalWindowInputs.keyTable) {
      case "lossControl":
        if (e.target.dataset.id === "confDuration") {
          newData[e.currentTarget.dataset.id] = Number(e.currentTarget.value);
        } else {
          newData[e.currentTarget.dataset.id] = e.currentTarget.value;
        }
        newData.recdate = Date.now();
        newData.confiscation = {};
        newData.confiscation.code = 1;
        newData.confiscation.name = "Лишение";
        newData.confiscation.note = "";
        if (newData.confDuration && newData.confDate) {
          let newEndDate = new Date(newData.confDate);
          newEndDate.setFullYear(newEndDate.getFullYear() + Number(newData.confDuration));
          newEndDate.setDate(newEndDate.getDate() - 1);
          newData.confDateEnd = newEndDate.toLocaleDateString().split(".").reverse().join("-");
        }
        setNewData(newData);
        if (saveKey) handleErrors();
        break;
      case "certificateWithdrawal":
        if (e.target) {
          newData[e.currentTarget.dataset.id] = e.currentTarget.value;
          newData.recdate = Date.now();
          // newData.confDateEnd = "2020-12-12"; //Тестовое значение, уточнить необходимость ввода данных
          // newData.confDocNum = "-"; //Тестовое значение, уточнить необходимость ввода данных
          newData.confiscation = {};
          newData.confiscation.code = 2;
          newData.confiscation.name = "Изъятие";
          newData.confiscation.note = "";
        } else {
          newData.userid = usersLib.find((item) => item.userid === e.value);
        }
        setNewData(newData);
        if (saveKey) handleErrors();
        break;
      case "boatDrivingLicenseSpecmarksList":
        newData.markDate = `${new Date().toISOString().slice(0, 10)} ${new Date()
          .toISOString()
          .slice(11, 23)}`;
        newData[e.currentTarget.dataset.id] = e.currentTarget.value;
        setNewData(structuredClone(newData));
        if (saveKey) handleErrors();
        break;
      default:
        break;
    }
    setNewData(structuredClone(newData));
  };

  const handleSave = () => {
    if (!handleErrors()) {
      switch (modalWindowInputs.keyTable) {
        case "lossControl":
          dispatch(addNewConfMark(newData, licenseIdModal));
          break;
        case "certificateWithdrawal":
          dispatch(addNewConfMark(newData, licenseIdModal));
          break;
        case "boatDrivingLicenseSpecmarksList":
          newData.markDate = `${new Date().toISOString().slice(0, 10)} ${new Date()
            .toISOString()
            .slice(11, 23)}`;
          newData.licenseId = licenseIdModal;
          newData.typeChange = type;
          setNewData(structuredClone(newData));
          if (newData.mark !== "") {
            dispatch(addNewSpecialMark(newData));
          }
          break;
        default:
          setShowModal(false);
          setNewData({});
          break;
      }
      setShowModal(false);
      setNewData({});
    } else {
      setSaveKey(true);
    }
  };

  const handleErrors = () => {
    let newErrors = {};
    switch (modalWindowInputs.keyTable) {
      case "certificateWithdrawal":
        errorsFields.forEach((elem) => {
          if (!newData[elem] || newData[elem] === "") {
            if (elem !== "userPositions") {
              newErrors[elem] = "Заполните поле";
            }
          }
        });
        break;
      case "lossControl":
        errorsFields.forEach((elem) => {
          if (!newData[elem] || newData[elem] === "") {
            newErrors[elem] = "Заполните поле";
          }
          if (elem === "confDuration") {
            if (Number(newData[elem]) < 1) {
              newErrors[elem] = "Значение должно быть больше 0";
            }
          }
          if (elem === "confDate") {
            if (new Date(newData[elem]) > new Date()) {
              newErrors[elem] = "Дата не может быть позднее текущей";
            }
          }
        });
      default:
        errorsFields.forEach((elem) => {
          if (!newData[elem] || newData[elem] === "") {
            newErrors[elem] = "Заполните поле";
          }
        });
        break;
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return true;
    } else {
      setErrors({});
      return false;
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
        setNewData({});
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>
          {modalWindowInputs.caption}
          {/* {options[type]} */}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <Form>
          {modalWindowInputs.nameColumn.map((item) => {
            switch (item.key) {
              case "userid":
                return (
                  <Form.Group className={styles["input-container"]}>
                    <Form.Label className={styles["label"]}>
                      {item.value}
                      {<span className={styles["red-dot"]}>*</span>}
                    </Form.Label>
                    <Select
                      noOptionsMessage={() => "Нет данных"}
                      classNamePrefix="react-select"
                      styles={errors[item.key] ? customErrorStyles : customStyles}
                      placeholder={"Выберите"}
                      data-id={item.key}
                      onChange={(e) => handleChange(e)}
                      value={(() => {
                        if (newData.hasOwnProperty(item.key)) {
                          return usersLib.find((item) => item.value == newData[item.key]);
                        }
                      })()}
                      isSearchable={false}
                      isDisabled={item.disabled}
                      name={item.key}
                      options={usersLib}
                    />
                    {errors[item.key] && <p className={styles["red-dot"]}>{errors[item.key]}</p>}
                  </Form.Group>
                );
              case "mark":
                return (
                  <Form.Group className={styles["input-container"]}>
                    <Form.Label className={styles["label"]}>
                      {item.value}
                      {<span className={styles["red-dot"]}>*</span>}
                    </Form.Label>
                    <input
                      data-id={item.key}
                      className={`${styles["form-input"]} ${!!errors[item.key] ? styles["red-border"] : ""}`}
                      type="text"
                      placeholder={"Введите"}
                      value={!!newData.mark ? newData.mark : ""}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                    {errors[item.key] && <p className={styles["red-dot"]}>{errors[item.key]}</p>}
                  </Form.Group>
                );
              case "confDate":
                return (
                  <Form.Group className={styles["input-container"]}>
                    <Form.Label className={styles["label"]}>
                      {item.value}
                      {<span className={styles["red-dot"]}>*</span>}
                    </Form.Label>
                    <input
                      className={`${styles["form-input"]} ${!!errors[item.key] ? styles["red-border"] : ""}`}
                      data-id={item.key}
                      type="date"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                    {errors[item.key] && <p className={styles["red-dot"]}>{errors[item.key]}</p>}
                  </Form.Group>
                );
              case "confDuration":
                return (
                  <Form.Group className={styles["input-container"]}>
                    <Form.Label className={styles["label"]}>
                      {item.value}
                      {<span className={styles["red-dot"]}>*</span>}
                    </Form.Label>
                    <input
                      className={`${styles["form-input"]} ${!!errors[item.key] ? styles["red-border"] : ""}`}
                      data-id={item.key}
                      placeholder={"Введите"}
                      type="number"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                    {errors[item.key] && <p className={styles["red-dot"]}>{errors[item.key]}</p>}
                  </Form.Group>
                );

              case "userPositions":
                break;
              case "markDate":
                break;
              case "confDateEnd":
                break;
              default:
                return (
                  <Form.Group className={styles["input-container"]}>
                    <Form.Label className={styles["label"]}>
                      {item.value}
                      {<span className={styles["red-dot"]}>*</span>}
                    </Form.Label>
                    <input
                      className={`${styles["form-input"]} ${!!errors[item.key] ? styles["red-border"] : ""}`}
                      data-id={item.key}
                      placeholder={"Введите"}
                      type="text"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                    {errors[item.key] && <p className={styles["red-dot"]}>{errors[item.key]}</p>}
                  </Form.Group>
                );
            }
          })}
        </Form>
      </Modal.Body>
      <Modal.Footer className={styles["form-footer"]}>
        {/* <Button
          variant="secondary"
          onClick={() => {
            handleErrors();
            setType(null);
            setShowModal(false);
            setDataForEdit(null);
            setNewData({});
          }}>
          Закрыть
        </Button> */}
        <div
          className={styles["save-btn"]}
          onClick={handleSave}>
          Сохранить
        </div>
      </Modal.Footer>
    </Modal>
  );
}
